import { apiBaseUrl }             from "./config"
import { getBaseHeader }          from "./utils"
import * as Model                 from "../../model"
import ApiError, { ApiErrorCode } from "../../error/api-error"
import { genericFetch } from "./common-service"

const ACCOUNTS     = "accounts"
const CHAPTERS     = "chapters"
const CLASSES      = "classes"
const INSTRUCTIONS = "instructions"

const instructionDoesNotFoundError = new ApiError(ApiErrorCode.NotFound, "L'instruction n'existe pas.")
const unexpectedError              = new Error("Unexpected error.")

export function findAccounts(instruction: Model.Instruction): Promise<Model.Account[]> {
	const url: string       = `${apiBaseUrl}/${INSTRUCTIONS}/${instruction.id}/${ACCOUNTS}`
	const init: RequestInit = { headers: getBaseHeader() }

	return fetch(url, init)
	.then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(value => value as Model.Account[])
			case 401:
				throw new ApiError(ApiErrorCode.Unauthorized, "Vous n'êtes pas autorisé à voir les comptes de cette instruction.")
			case 404:
				throw instructionDoesNotFoundError
		}
		throw new Error("Unexpected error.")
	})
}

export function findChapters(instruction: Model.Instruction): Promise<Model.Chapter[]> {
	const url: string       = `${apiBaseUrl}/${INSTRUCTIONS}/${instruction.id}/${CHAPTERS}`
	const init: RequestInit = { headers: getBaseHeader() }

	return fetch(url, init)
	.then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(value => value as Model.Chapter[])
			case 401:
				throw new ApiError(ApiErrorCode.Unauthorized, "Vous n'êtes pas autorisé à voir les chapitres de cette instruction.")
			case 404:
				throw new ApiError(ApiErrorCode.NotFound, "L'instruction n'existe pas.")
		}
		throw unexpectedError
	})
}

export function findClasses(instruction: Model.Instruction): Promise<Model.Class[]> {
	const url: string       = `${apiBaseUrl}/${INSTRUCTIONS}/${instruction.id}/${CLASSES}`
	const init: RequestInit = { headers: getBaseHeader() }

	return fetch(url, init)
	.then(response => {
		switch (response.status) {
			case 200:
				return response.json().then(value => value as Model.Class[])
			case 401:
				throw new ApiError(ApiErrorCode.Unauthorized, "Vous n'êtes pas autorisé à voir les classes de cette instruction.")
			case 404:
				throw new ApiError(ApiErrorCode.NotFound, "L'instruction n'existe pas.")
		}
		throw unexpectedError
	})
}

export function findInstructionById(
	id: number,
	signal: AbortSignal
): Promise<Model.Instruction> {
	const url: string       = `${apiBaseUrl}/${INSTRUCTIONS}/${id}`
	const init: RequestInit = { headers: getBaseHeader(), signal }

	return genericFetch<Model.Instruction>(url, init)
}
export function updateInstructionById(
	id: number,
	body:any,
	accountId:number
	) {
	const url = `${apiBaseUrl}/${INSTRUCTIONS}/${id}/${ACCOUNTS}/${accountId}`
	const init = {
		body: JSON.stringify(body),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "PUT"
	}

	return genericFetch(url, init)
}
export function findInstructions(
	signal: AbortSignal
): Promise<Model.Instruction[]> {
	const url = `${apiBaseUrl}/${INSTRUCTIONS}`
	const init: RequestInit = { headers: getBaseHeader(), signal }
	return genericFetch<Model.Instruction[]>(url, init)
}



// WEBPACK FOOTER //
// ./src/service/sfp/instructions-service-2.ts